import React, { useRef, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { authService } from 'services';
import { showTostify } from 'utils/common-functions';
import { routes } from 'utils/routes';
import CustomToast from 'views/components/form-inputs/alert/index';
import Logo from 'assets/images/logo.svg';
import { AuthImg } from './images';

const ResetPassword = () => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const toastRef = useRef<any>(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const id = query.get('id') || '';
  const key = query.get('key') || '';

  const formik = useFormik({
    initialValues: {
      id: id,
      key: key,
      new_password: '',
      confirm_password: '',
    },
    validationSchema: Yup.object({
      new_password: Yup.string()
        .min(8, 'Password must be at least 8 characters')
        .required('New password is required'),
      confirm_password: Yup.string()
        .oneOf([Yup.ref('new_password')], 'Passwords must match')
        .required('Confirm password is required'),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const data = await authService.updatePassword(values);
        if (data.error === false) {
          setTimeout(() => {
            navigate(routes.login);
          }, 2000);
          showTostify(toastRef, 'success', data.message);
        } else {
          showTostify(toastRef, 'error', data.message);
        }
      } catch (err: any) {
        showTostify(toastRef, 'error', err.message);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      <div className="auth-details flex h-screen">
        <CustomToast ref={toastRef} />

        <div className="flex align-items-center justify-content-center flex-column w-6">
          <div className="login-width my-auto">
            <form onSubmit={formik.handleSubmit}>
              <img src={Logo} alt="Clapping Hands" className='w-13rem' />
              <h2 className="flex align-items-center mt-4">Reset Password? 🔒</h2>
              <p className="mb-5">Enter your new password to regain access to your account.</p>

              <div className="form-group">
                <div className="login-input">
                  <label htmlFor="email">New password</label>
                  <Password
                    id="new_password"
                    name="new_password"
                    value={formik.values.new_password}
                    onBlur={formik.handleBlur}
                    onChange={(e) => formik.setFieldValue('new_password', e.target.value)}
                    placeholder="Enter here" toggleMask
                    required
                    className={`form-control ${formik.errors.new_password && formik.touched.new_password ? 'p-invalid' : ''}`}
                  />
                  {formik.touched.new_password && formik.errors.new_password && (
                    <Message severity="error" text={formik.errors.new_password} />
                  )}
                </div>
              </div>

              <div className="form-group">
                <div className="login-input">
                  <label htmlFor="email">Confirm password</label>
                  <Password
                    id="confirm_password"
                    name="confirm_password"
                    placeholder="Enter here"
                    value={formik.values.confirm_password}
                    onBlur={formik.handleBlur}
                    onChange={(e) => formik.setFieldValue('confirm_password', e.target.value)}
                    toggleMask
                    required
                    feedback={false}
                    className={`form-control ${formik.errors.confirm_password && formik.touched.confirm_password ? 'p-invalid' : ''}`}
                  />
                  {formik.touched.confirm_password && formik.errors.confirm_password && (
                    <Message severity="error" text={formik.errors.confirm_password} />
                  )}
                </div>
              </div>

              <div className="flex justify-content-center">
                <Button
                  label={loading ? "" : "Reset Password"}
                  type="submit"
                  className='primary w-full'
                  disabled={!formik.isValid || formik.isSubmitting}
                  loading={loading}
                />
              </div>

              <div className="account-details flex justify-content-center mt-3 ">
                <p className='mb-0 mt-0'>
                  <Link to="/login"><i className="pi pi-arrow-left"></i>&nbsp; Back to login</Link>
                </p>
              </div>
            </form>
          </div>

          <div className='copy-right mt-auto mb-4'>
            <p className='mt-4'>© 2024 Bookmydiscount, All rights reserved.</p>
          </div>
        </div>


        <div className="flex justify-content-end align-items-center bg-white w-6 p-4 right-images">
          <div className="img-container">
            <img src={AuthImg} className="character-image" alt="Login Banner" />
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;